import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Trans } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./CarCheckoutDateRange.module.scss";
import { useCarCheckoutDateRange } from "./useCarCheckoutDateRange";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type CarCheckoutDateRangeProps = {
  pickupTime: string;
  dropoffTime: string;
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.CarCheckoutDateRange;

export const CarCheckoutDateRange = (props: CarCheckoutDateRangeProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { pickupDateAndTime, dropoffDateAndTime } =
    useCarCheckoutDateRange(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("time-text")}>
        <Trans
          i18nKey={"checkout.cars.pickupDate"}
          components={{
            label: <span className={cn("label")} />,
            date: <span className={cn("date")} />,
          }}
          values={pickupDateAndTime}
        />
      </div>
      <div className={cn("time-text")}>
        <Trans
          i18nKey={"checkout.cars.dropoffDate"}
          components={{
            label: <span className={cn("label")} />,
            date: <span className={cn("date")} />,
          }}
          values={dropoffDateAndTime}
        />
      </div>

      {children}
    </div>
  );
};
